import { render } from "./CustomerGroupDetail.vue?vue&type=template&id=7db673e3"
import script from "./CustomerGroupDetail.vue?vue&type=script&lang=js"
export * from "./CustomerGroupDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__